module.exports = __webpack_public_path__ + "img/about.2f75ddb0.jpg";